// /platforms: the showroom shelf. Built with our own methods, run as products,
// sold through partners. Benjamin links out to its own site; Maestro links to
// its own stage at /maestro, where the full thesis lives.

const platformsContent = {
  'en-US': {
    seo: {
      title: 'Platforms | Lean it 101',
      description:
        'Benjamin, the AI support intelligence platform, and Maestro, the operating system for software delivery in the AI era: the products Lean it 101 builds with its own methods; partners take them to market.',
    },
    hero: {
      kicker: 'Platforms',
      headline: 'Products born on our own production line.',
      body: 'The platforms are the showroom of how we work. We build them under the Lean Pyramid, we run them in production, and they reach the market through partners rather than around them.',
    },
    benjamin: {
      kicker: 'Benjamin · support intelligence',
      title: 'Support that answers from your knowledge alone',
      body: 'Benjamin resolves support requests across web chat, WhatsApp and email, grounded strictly in your own knowledge base and business rules, escalating to a human with full context when judgment is needed. It has its own home, with pricing and a live demo.',
      points: ['Answers come only from your own knowledge base', 'Human escalation with the whole conversation attached', 'Web chat, WhatsApp, email and in-product'],
      cta: 'Visit benjaminintelligence.com',
      href: 'https://benjaminintelligence.com',
    },
    maestro: {
      kicker: 'Maestro · the delivery operating system',
      title: 'Delivery you can see, forecast and govern',
      body: 'Maestro is the operating system for software delivery in the AI era: releases forecast by Monte Carlo over your own throughput, WIP that respects limits, decisions waiting on named people, and agents whose work arrives with its evidence. It runs our own engagements today.',
      points: ['Burn-ups and forecasts computed from observed throughput', 'Humans and agents on one governed board', 'The vault: living standards agents actually follow'],
      shot: {
        src: '/images/maestro/map.jpg',
        alt: 'Maestro map view: releases against features and epics, with cards moving toward production',
        caption: 'The map: releases climb toward production against features and epics.',
      },
      note: 'Maestro is in production with our engagements and opens to partners first.',
      cta: 'Why delivery needs a new operating system',
      href: '/maestro',
    },
    loopLine: {
      text: 'Build with Maestro, support with Benjamin, and every release will teach your support agent what just shipped. That loop is what we are closing now.',
      cta: 'See the loop on How we work',
      href: '/how-we-work#loop',
    },
    partners: {
      kicker: 'Partners',
      title: 'The platforms reach the market through partners',
      body: 'The first partner cohort is forming: resellers, integrators and consultancies carrying Benjamin and Maestro to their clients with our delivery support behind them.',
      points: [
        'Recurring margin on platform subscriptions you originate',
        'Our engineers behind every deployment your clients buy',
        'The showroom, the proposals and the demo tenant, ready to sell with',
      ],
      cta: 'Start a partner conversation',
    },
  },
  'pt-BR': {
    seo: {
      title: 'Plataformas | Lean it 101',
      description:
        'Benjamin, a plataforma de inteligência de suporte com IA, e Maestro, o sistema operacional da entrega de software na era da IA: os produtos que a Lean it 101 constrói com seus próprios métodos; parceiros os levam ao mercado.',
    },
    hero: {
      kicker: 'Plataformas',
      headline: 'Produtos nascidos na nossa própria linha de produção.',
      body: 'As plataformas são o showroom de como trabalhamos. Nós as construímos sob a Pirâmide Lean, operamos em produção, e eles chegam ao mercado por parceiros, não por nós mesmos.',
    },
    benjamin: {
      kicker: 'Benjamin · inteligência de suporte',
      title: 'Suporte que responde só a partir do seu conhecimento',
      body: 'O Benjamin resolve chamados em web chat, WhatsApp e email, ancorado estritamente na sua base de conhecimento e nas suas regras de negócio, escalando para um humano com contexto completo quando o julgamento é necessário. Ele tem casa própria, com preços e demo ao vivo.',
      points: ['As respostas saem apenas da sua própria base de conhecimento', 'Escalação humana com a conversa inteira anexada', 'Web chat, WhatsApp, email e in-product'],
      cta: 'Visite benjaminintelligence.com',
      href: 'https://benjaminintelligence.com',
    },
    maestro: {
      kicker: 'Maestro · o sistema operacional da entrega',
      title: 'Entrega que você enxerga, prevê e governa',
      body: 'O Maestro é o sistema operacional da entrega de software na era da IA: releases previstas por Monte Carlo sobre o seu próprio throughput, WIP que respeita limites, decisões esperando pessoas nomeadas, e agentes cujo trabalho chega com sua evidência. Ele opera nossos próprios engajamentos hoje.',
      points: ['Burn-ups e previsões calculadas do throughput observado', 'Humanos e agentes em um board governado', 'O vault: padrões vivos que os agentes de fato seguem'],
      shot: {
        src: '/images/maestro/map.jpg',
        alt: 'Visão de mapa do Maestro: releases contra features e épicos, com cartões avançando para produção',
        caption: 'O mapa: releases sobem em direção à produção contra features e épicos.',
      },
      note: 'O Maestro está em produção nos nossos engajamentos e abre primeiro para parceiros.',
      cta: 'Por que a entrega precisa de um novo sistema operacional',
      href: '/maestro',
    },
    loopLine: {
      text: 'Construa com Maestro, atenda com Benjamin, e cada release vai ensinar ao seu agente de suporte o que acabou de entrar no ar. É o loop que estamos fechando agora.',
      cta: 'Veja o loop em Como trabalhamos',
      href: '/how-we-work#loop',
    },
    partners: {
      kicker: 'Parceiros',
      title: 'As plataformas chegam ao mercado por parceiros',
      body: 'A primeira turma de parceiros está se formando: revendas, integradores e consultorias levando Benjamin e Maestro aos seus clientes com nosso suporte de entrega por trás.',
      points: [
        'Margem recorrente nas assinaturas de plataforma que você origina',
        'Nossos engenheiros por trás de cada implantação que seus clientes compram',
        'O showroom, as propostas e o tenant de demonstração, prontos para vender junto',
      ],
      cta: 'Iniciar uma conversa de parceria',
    },
  },
  es: {
    seo: {
      title: 'Plataformas | Lean it 101',
      description:
        'Benjamin, la plataforma de inteligencia de soporte con IA, y Maestro, el sistema operativo de la entrega de software en la era de la IA: los productos que Lean it 101 construye con sus propios métodos; socios los llevan al mercado.',
    },
    hero: {
      kicker: 'Plataformas',
      headline: 'Productos nacidos en nuestra propia línea de producción.',
      body: 'Las plataformas son el showroom de cómo trabajamos. Las construimos bajo la Pirámide Lean, las operamos en producción, y llegan al mercado a través de socios, no de nosotros mismos.',
    },
    benjamin: {
      kicker: 'Benjamin · inteligencia de soporte',
      title: 'Soporte que responde solo desde tu conocimiento',
      body: 'Benjamin resuelve solicitudes en web chat, WhatsApp y email, anclado estrictamente en tu base de conocimiento y tus reglas de negocio, escalando a un humano con contexto completo cuando hace falta juicio. Tiene casa propia, con precios y demo en vivo.',
      points: ['Las respuestas salen solo de tu propia base de conocimiento', 'Escalación humana con toda la conversación adjunta', 'Web chat, WhatsApp, email e in-product'],
      cta: 'Visita benjaminintelligence.com',
      href: 'https://benjaminintelligence.com',
    },
    maestro: {
      kicker: 'Maestro · el sistema operativo de la entrega',
      title: 'Entrega que puedes ver, pronosticar y gobernar',
      body: 'Maestro es el sistema operativo de la entrega de software en la era de la IA: releases pronosticadas por Monte Carlo sobre tu propio throughput, WIP que respeta límites, decisiones esperando a personas con nombre, y agentes cuyo trabajo llega con su evidencia. Hoy opera nuestros propios compromisos.',
      points: ['Burn-ups y pronósticos calculados del throughput observado', 'Humanos y agentes en un tablero gobernado', 'El vault: estándares vivos que los agentes realmente siguen'],
      shot: {
        src: '/images/maestro/map.jpg',
        alt: 'Vista de mapa de Maestro: releases contra features y épicas, con tarjetas avanzando a producción',
        caption: 'El mapa: las releases suben hacia producción contra features y épicas.',
      },
      note: 'Maestro está en producción en nuestros compromisos y se abre primero a socios.',
      cta: 'Por qué la entrega necesita un nuevo sistema operativo',
      href: '/maestro',
    },
    loopLine: {
      text: 'Construye con Maestro, atiende con Benjamin, y cada release le enseñará a tu agente de soporte lo que acaba de salir. Ese es el loop que estamos cerrando ahora.',
      cta: 'Ve el loop en Cómo trabajamos',
      href: '/how-we-work#loop',
    },
    partners: {
      kicker: 'Socios',
      title: 'Las plataformas llegan al mercado a través de socios',
      body: 'La primera cohorte de socios se está formando: resellers, integradores y consultoras llevando Benjamin y Maestro a sus clientes con nuestro soporte de entrega detrás.',
      points: [
        'Margen recurrente en las suscripciones de plataforma que originas',
        'Nuestros ingenieros detrás de cada implementación que compran tus clientes',
        'El showroom, las propuestas y el tenant de demostración, listos para vender juntos',
      ],
      cta: 'Iniciar una conversación de socios',
    },
  },
}

const normalize = (language) => {
  if (!language) return 'en-US'
  const lower = language.toLowerCase()
  if (lower.startsWith('pt')) return 'pt-BR'
  if (lower.startsWith('es')) return 'es'
  return 'en-US'
}

export const getPlatformsContent = (language) => platformsContent[normalize(language)]
export default platformsContent
